import React from "react";
import { Link, useParams, useLocation } from "react-router-dom";
import { getInsightBySlug } from "../../data/insightsData.js";
import InsightDetailContent from "../../components/InsightDetailContent.jsx";

const TYPE_LABELS_DE = {
  ARTICLE: "Artikel",
};

function formatInsightDate(dateValue) {
  const parsed = new Date(dateValue);
  if (Number.isNaN(parsed.getTime())) return dateValue;
  return parsed.toLocaleDateString("de-DE", {
    day: "2-digit",
    month: "long",
    year: "numeric",
  });
}

function formatReadTime(readTime) {
  const match = String(readTime).match(/(\d+)\s*MIN\s*READ/i);
  if (!match) return readTime;
  return `${match[1]} Min. Lesezeit`;
}

export default function InsightDetailPage() {
  const { slug } = useParams();
  const location = useLocation();
  const insightsListPath = location.pathname.startsWith("/sales") ? "/sales/insights" : "/medical/insights";

  const article = getInsightBySlug(slug);

  if (!article) {
    return (
      <div className="bg-white py-16">
        <div className="container-app">
          <p className="text-sm font-medium text-gray-500">
            Einblick nicht gefunden.
          </p>
          <Link
            to={insightsListPath}
            className="mt-4 inline-flex text-sm font-semibold text-gray-900 underline underline-offset-4"
          >
            Zurück zu allen Einblicken
          </Link>
        </div>
      </div>
    );
  }

  const {
    topic,
    type,
    date,
    title,
    image,
    readTime = "8 Min. Lesezeit",
    authors,
  } = article;

  const authorsList =
    authors && authors.length
      ? authors
      : ["REPEXO Medical Einblicke-Team"];

  return (
    <section id="section-insight-detail" className="bg-white py-10 md:py-14">
      <div className="container-app">
        {/* Tag pill */}
        <div className="inline-flex rounded-full border border-gray-300 px-4 py-1 text-xs font-semibold uppercase tracking-[0.16em] text-gray-700">
          {topic}
        </div>

        {/* Title */}
        <h1 className="mt-5 text-3xl font-semibold tracking-tight text-gray-900 sm:text-4xl md:text-[2.6rem] md:leading-tight">
          {title}
        </h1>

        {/* Authors */}
        <p className="mt-3 text-sm text-gray-700">
          Von{" "}
          {authorsList.map((name, index) => (
            <span key={name}>
              <button
                type="button"
                className="text-sm font-semibold text-gray-900 underline-offset-4 hover:underline"
              >
                {name}
              </button>
              {index < authorsList.length - 1 && ", "}
            </span>
          ))}
        </p>

        {/* Meta line */}
        <p className="mt-4 text-xs font-semibold uppercase tracking-[0.16em] text-gray-600">
          {TYPE_LABELS_DE[type] ?? type} &nbsp; {formatInsightDate(date)} &nbsp; {formatReadTime(readTime)}
        </p>

        {/* Main hero image */}
        <div className="mt-8 overflow-hidden rounded-[26px]">
          <img
            src={image}
            alt={title}
            className="h-64 w-full object-cover md:h-80 lg:h-96"
          />
        </div>
      </div>

      {/* Detailed content: same two-column layout as service / Geschichte / Karriere */}
      {article.detail && (
        <InsightDetailContent insight={article} />
      )}
    </section>
  );
}

